<main class="general">
  @if (infoTransaction()) {
  @if (shouldDisplayPolling()) {
  <section class="general__info">
    <div class="transaction-header">
      <h1>
        TRANSACCIÓN {{ states()[infoTransaction().id_pay_status]?.toUpperCase() }}
      </h1>
    </div>
    <div class="card-content">
      @if (certificatesStatus().length > 0) {
      <section class="certificates-status">
        <div class="certificates-status__notice">
          <p>
            Por favor espera, en este momento se está generando tu certificado. Esto puede tomar algunos minutos.
          </p>
          <p>
            Si lo prefieres puedes cerrar esta ventana, El certificado será enviado al correo
            <span class="bold">{{ infoTransaction().email }}</span> tan pronto esté listo.
          </p>
        </div>
        <div class="certificates-status__list">
          @for (cert of certificatesStatus(); track cert.matricula) {
          <div class="certificate-item" [ngClass]="{'pending-item': cert.status === 'pending'}">
            <div class="certificate-item__info">
              <span class="matricula">{{ cert.matricula }}</span>
              @if (cert.errorMessage) {
              <span class="certificate-item__error-message">
                <img src="assets/icons/color/alert.svg" alt="Error Icon" />
                {{ cert.errorMessage }}
              </span>
              }
              @if (cert.pin) {
              <span [class]="cert.status === 'voucher' ? 'voucher' : 'pin'">
                {{ cert.status === 'voucher' ? 'Voucher' : 'Pin' }}: {{ cert.pin }}
              </span>
              }
            </div>
            <div class="certificate-item__status">
              @switch (cert.status) {
              @case ('loading') { <div class="status-box loading"><span>Cargando</span>
                <div class="spinner"></div>
              </div> }
              @case ('ready') { <button class="status-box ready" (click)="downloadCertificate(cert)">Descargar</button>
              }
              @case ('pending') { <div class="status-box pending"><span>Pendiente</span></div> }
              @case ('voucher') { <a href="assets/pdf/instrucciones-voucher.pdf" download="Instrucciones Voucher.pdf"
                class="status-box voucher">Descargar Voucher</a> }
              @case ('error') { <div class="status-box error"><span>Error</span></div> }
              }
            </div>
          </div>
          }
        </div>
        @if (areAllReadyToDownload()) {
        <div class="certificates-status__download-all">
          <button class="action-btn btn-primary" (click)="downloadAllCertificates()">Descargar Todos</button>
        </div>
        }
      </section>
      }
    </div>
  </section>

  <section class="general__info">
    <div class="card-content">
      <div id="receiptContent" #receiptContent class="receipt-details">
        <div>
          <p>Fecha:</p>
          <p>{{ infoTransaction().created_at | date:'dd/MM/yyyy - hh:mm a' }}</p>
        </div>
        <div>
          <p>Valor:</p>
          <p>{{ infoTransaction().amount | currency:'COP':'symbol-narrow':'1.0-0' }}</p>
        </div>
        <div>
          <p>ID de pago:</p>
          <p>{{ infoTransaction().pay_id || '---' }}</p>
        </div>
        <div>
          <p>Medio de pago:</p>
          <p>{{ meansPay()[infoTransaction().id_payment_method] }}</p>
        </div>
        <div>
          <p>Estado:</p>
          <p>{{ states()[infoTransaction().id_pay_status] }}</p>
        </div>
        <div>
          <p>ID solicitud:</p>
          <p>{{ infoTransaction().id_request }}</p>
        </div>
        <div>
          <p>Correo:</p>
          <p>{{ infoTransaction().email }}</p>
        </div>
      </div>
    </div>
    <div class="actions-grid">
      @if(infoTransaction().id_pay_status === 14 || infoTransaction().id_pay_status === 9) {
      <button class="action-btn btn-secondary" (click)="downloadReceipt()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="7 10 12 15 17 10"></polyline>
          <line x1="12" y1="15" x2="12" y2="3"></line>
        </svg>
        Descargar comprobante de pago
      </button>
      <button class="action-btn btn-secondary" (click)="emailReceipt()">Enviar por correo comprobante de pago</button>
      }
      @if(infoTransaction().id_pay_status === 14) {
      <button class="action-btn btn-primary" routerLink="/">Solicitar nuevo certificado</button>
      }
      @if((infoTransaction().id_pay_status === 12 || infoTransaction().id_pay_status === 9) && !statusBotPix()) {
      <button class="action-btn btn-primary" (click)="onRetry()">Reintentar compra</button>
      }
      <button class="action-btn btn-secondary" routerLink="/">Finalizar</button>
    </div>
  </section>

  } @else {
  <section class="general__info unified">
    <div class="transaction-header">
      <h1>
        TRANSACCIÓN {{ states()[infoTransaction().id_pay_status]?.toUpperCase() }}
      </h1>
    </div>

    <div class="card-content">
      <div class="transaction-messages">
        @if (infoTransaction().id_pay_status === 10) {
        <p>
          <span>Estamos validando tu pago. Por favor espera a que confirmemos la transacción.</span>
        </p>
        } @else {
        @if (!showOutHour() && !showWeekend()) {
        <p>
          @if (infoTransaction().id_pay_status === 9) {
          <span> Tu solicitud no se ha generado. Intenta de nuevo </span>
          } @else {
          @if(showStatusTransaction()){
        <div [innerHTML]="messageStatusTransaction()"></div>
        } @else {
        <span>
          @if (infoTransaction().id_state === 6) {
          En los próximos minutos recibirás información sobre tu certificado al correo indicado.
          } @else {
          Recibirás el certificado en el correo
          <span class="bold">{{ infoTransaction().email }}</span> en aproximadamente 30 minutos.
          }
        </span>
        }
        }
        </p>
        } @if (showOutHour() && !showWeekend()) {
        <p>
          @if (infoTransaction().id_pay_status === 9) {
          <span> Tu solicitud no se ha generado. Intenta de nuevo </span>
          } @else {
          <span>
            Tu certificado(s) será generado a partir de las 6:30 am. Recibirás el certificado en el correo indicado.
          </span>
          }
        </p>
        } @if (showWeekend()) {
        <p>
          @if (infoTransaction().id_pay_status === 9) {
          <span> Tu solicitud no se ha generado. Intenta de nuevo </span>
          } @else {
          <span>
            Tu certificado(s) será generado a partir de las 6:30 am de lunes a sábado.
          </span>
          <span style="text-align: center">
            (Recuerda que tu certificado será tramitado el lunes.)
          </span>
          <span> Recibirás el certificado en el correo indicado. </span>
          }
        </p>
        }
        }
      </div>
      <div id="receiptContent" #receiptContent class="receipt-details">
        <div>
          <p>Fecha:</p>
          <p>{{ infoTransaction().created_at | date:'dd/MM/yyyy - hh:mm a' }}</p>
        </div>
        <div>
          <p>Valor:</p>
          <p>{{ infoTransaction().amount | currency:'COP':'symbol-narrow':'1.0-0' }}</p>
        </div>
        <div>
          <p>ID de pago:</p>
          <p>{{ infoTransaction().pay_id || '---' }}</p>
        </div>
        <div>
          <p>Medio de pago:</p>
          <p>{{ meansPay()[infoTransaction().id_payment_method] }}</p>
        </div>
        <div>
          <p>Estado:</p>
          <p>{{ states()[infoTransaction().id_pay_status] }}</p>
        </div>
        <div>
          <p>ID solicitud:</p>
          <p>{{ infoTransaction().id_request }}</p>
        </div>
        <div>
          <p>Correo:</p>
          <p>{{ infoTransaction().email }}</p>
        </div>
      </div>
    </div>

    <div class="actions-grid">
      @if(infoTransaction().id_pay_status === 14 || infoTransaction().id_pay_status === 9) {
      <button class="action-btn btn-secondary" (click)="downloadReceipt()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="7 10 12 15 17 10"></polyline>
          <line x1="12" y1="15" x2="12" y2="3"></line>
        </svg>
        Descargar comprobante de pago
      </button>
      <button class="action-btn btn-secondary" (click)="emailReceipt()">Enviar por correo comprobante de pago</button>
      }
      @if(infoTransaction().id_pay_status === 14) {
      <button class="action-btn btn-primary" routerLink="/">Solicitar nuevo certificado</button>
      }
      @if((infoTransaction().id_pay_status === 12 || infoTransaction().id_pay_status === 9) && !statusBotPix()) {
      <button class="action-btn btn-primary" (click)="onRetry()">Reintentar compra</button>
      }
      <button class="action-btn btn-secondary" routerLink="/">Finalizar</button>
    </div>

    @if(infoTransaction().id_pay_status === 10) {
    <div class="recharge-container">
      <button (click)="recharge()" class="action-btn btn-primary">Recargar Estado</button>
    </div>
    }
  </section>
  }
  }
</main>


@if (openModal()) {
<section class="modal-alert">
  <section>
    <div class="first-text">
      <span>Estamos actualizando el estado de la solicitud</span>
    </div>
    <div class="second-text">Te recomendamos no cerrar el navegador</div>
    <section class="loading">
      <div class="gooey">
        <span class="dot"></span>
        <div class="dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </section>
  </section>
</section>
}

@if (isProcessingAction()) {
<section class="modal-alert">
  <section>
    <div class="first-text">
      <span>Estamos procesando tu solicitud</span>
      <br>
      <span>Esto puede tardar algunos minutos</span>
    </div>
    <div class="second-text">Te recomendamos no cerrar el navegador</div>
    <section class="loading">
      <div class="gooey">
        <span class="dot"></span>
        <div class="dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </section>
  </section>
</section>
}